import { AxiosError } from 'axios'
import { toast } from 'react-toastify'

const showErrorToast = (e: unknown) => {
  const error = e as AxiosError<{ message: string }>

  if (error?.response?.status === 401) {
    return
  }

  let message = error.message

  if (error.response?.data?.message) {
    message = error.response?.data?.message
  }

  toast.error(message, { bodyClassName: 'error__body', theme: 'colored' })
}

export default showErrorToast
